"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAdRequestToJSON = exports.CreateAdRequestFromJSONTyped = exports.CreateAdRequestFromJSON = exports.instanceOfCreateAdRequest = void 0;
var runtime_1 = require("../runtime");
var AdAssets_1 = require("./AdAssets");
var AdCallToActionRequest_1 = require("./AdCallToActionRequest");
var AdSurvey_1 = require("./AdSurvey");
var AdThirdPartyTracking_1 = require("./AdThirdPartyTracking");
var AssetFormat_1 = require("./AssetFormat");
var Delivery_1 = require("./Delivery");
var DuplicationType_1 = require("./DuplicationType");
var Placement_1 = require("./Placement");
var SlotPositionsInner_1 = require("./SlotPositionsInner");
/**
 * Check if a given object implements the CreateAdRequest interface.
 */
function instanceOfCreateAdRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "assets" in value;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
exports.instanceOfCreateAdRequest = instanceOfCreateAdRequest;
function CreateAdRequestFromJSON(json) {
    return CreateAdRequestFromJSONTyped(json, false);
}
exports.CreateAdRequestFromJSON = CreateAdRequestFromJSON;
function CreateAdRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'advertiserName': !(0, runtime_1.exists)(json, 'advertiser_name') ? undefined : json['advertiser_name'],
        'assets': (0, AdAssets_1.AdAssetsFromJSON)(json['assets']),
        'name': json['name'],
        'tagline': !(0, runtime_1.exists)(json, 'tagline') ? undefined : json['tagline'],
        'thirdPartyTracking': !(0, runtime_1.exists)(json, 'third_party_tracking') ? undefined : (json['third_party_tracking'].map(AdThirdPartyTracking_1.AdThirdPartyTrackingFromJSON)),
        'survey': !(0, runtime_1.exists)(json, 'survey') ? undefined : (0, AdSurvey_1.AdSurveyFromJSON)(json['survey']),
        'slotPositions': !(0, runtime_1.exists)(json, 'slot_positions') ? undefined : (json['slot_positions'].map(SlotPositionsInner_1.SlotPositionsInnerFromJSON)),
        'notaryMetadata': !(0, runtime_1.exists)(json, 'notary_metadata') ? undefined : json['notary_metadata'],
        'dvClientCode': !(0, runtime_1.exists)(json, 'dv_client_code') ? undefined : json['dv_client_code'],
        'adSetId': !(0, runtime_1.exists)(json, 'ad_set_id') ? undefined : json['ad_set_id'],
        'callToAction': !(0, runtime_1.exists)(json, 'call_to_action') ? undefined : (0, AdCallToActionRequest_1.AdCallToActionRequestFromJSON)(json['call_to_action']),
        'delivery': !(0, runtime_1.exists)(json, 'delivery') ? undefined : (0, Delivery_1.DeliveryFromJSON)(json['delivery']),
        'draftId': !(0, runtime_1.exists)(json, 'draft_id') ? undefined : json['draft_id'],
        'placements': !(0, runtime_1.exists)(json, 'placements') ? undefined : (json['placements'].map(Placement_1.PlacementFromJSON)),
        'assetFormat': !(0, runtime_1.exists)(json, 'asset_format') ? undefined : (0, AssetFormat_1.AssetFormatFromJSON)(json['asset_format']),
        'assetUri': !(0, runtime_1.exists)(json, 'asset_uri') ? undefined : json['asset_uri'],
        'duplicationType': !(0, runtime_1.exists)(json, 'duplication_type') ? undefined : (0, DuplicationType_1.DuplicationTypeFromJSON)(json['duplication_type']),
        'duplicatedAdId': !(0, runtime_1.exists)(json, 'duplicated_ad_id') ? undefined : json['duplicated_ad_id'],
        'copiedAdId': !(0, runtime_1.exists)(json, 'copied_ad_id') ? undefined : json['copied_ad_id'],
        'importedFromAssetLibrary': !(0, runtime_1.exists)(json, 'imported_from_asset_library') ? undefined : json['imported_from_asset_library'],
    };
}
exports.CreateAdRequestFromJSONTyped = CreateAdRequestFromJSONTyped;
function CreateAdRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'advertiser_name': value.advertiserName,
        'assets': (0, AdAssets_1.AdAssetsToJSON)(value.assets),
        'name': value.name,
        'tagline': value.tagline,
        'third_party_tracking': value.thirdPartyTracking === undefined ? undefined : (value.thirdPartyTracking.map(AdThirdPartyTracking_1.AdThirdPartyTrackingToJSON)),
        'survey': (0, AdSurvey_1.AdSurveyToJSON)(value.survey),
        'slot_positions': value.slotPositions === undefined ? undefined : (value.slotPositions.map(SlotPositionsInner_1.SlotPositionsInnerToJSON)),
        'notary_metadata': value.notaryMetadata,
        'dv_client_code': value.dvClientCode,
        'ad_set_id': value.adSetId,
        'call_to_action': (0, AdCallToActionRequest_1.AdCallToActionRequestToJSON)(value.callToAction),
        'delivery': (0, Delivery_1.DeliveryToJSON)(value.delivery),
        'draft_id': value.draftId,
        'placements': value.placements === undefined ? undefined : (value.placements.map(Placement_1.PlacementToJSON)),
        'asset_format': (0, AssetFormat_1.AssetFormatToJSON)(value.assetFormat),
        'asset_uri': value.assetUri,
        'duplication_type': (0, DuplicationType_1.DuplicationTypeToJSON)(value.duplicationType),
        'duplicated_ad_id': value.duplicatedAdId,
        'copied_ad_id': value.copiedAdId,
        'imported_from_asset_library': value.importedFromAssetLibrary,
    };
}
exports.CreateAdRequestToJSON = CreateAdRequestToJSON;
